import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ProcessDefinitionEntity } from './process-definition.entity';

@Index('process__fk_process_definition__id_fk', ['fkProcessDefinitionId'], {})
@Entity('process')
export class ProcessEntity extends BaseEntity {
	@Column('int', { name: '_fk_process_definition__id', unsigned: true })
	public fkProcessDefinitionId!: number;

	@Column('int', { name: 'object__id' })
	public objectId!: number;

	@Column('int', { name: 'object_record__id' })
	public objectRecordId!: number;

	@Column('datetime', { name: 'expiration', nullable: true })
	public expiration!: Date | null;

	@Column('datetime', { name: 'follow_up', nullable: true })
	public followUp!: Date | null;

	@Column('varchar', { name: 'status', length: 255, default: () => "'1'" })
	public status!: string;

	@Column('datetime', { name: 'sort_date', nullable: true })
	public sortDate!: Date | null;

	@ManyToOne(
		() => ProcessDefinitionEntity,
		(processDefinition) => processDefinition.processes,
		{ onDelete: 'RESTRICT', onUpdate: 'RESTRICT' },
	)
	@JoinColumn([
		{ name: '_fk_process_definition__id', referencedColumnName: 'id' },
	])
	public fkProcessDefinition!: ProcessDefinitionEntity;
}
